import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Collapse } from 'antd';
const { Panel } = Collapse;

import './styles.less';

export const SimpleCollapse = ( props ) => {
    const [ expanded, setExpanded ] = useState( false );

    useEffect( () => {
        if ( props.expand !== undefined ) {
            setExpanded( props.expand );
        }
    }, [ props.expand ] );

    // Construct the classes to use for the root component.
    const classes = classnames(
        'simple-collapse',
        { [ props.className ]: Boolean( props.className ) },
    );

    return (
        <Collapse
            className={ classes }
            style={ props.style }
            defaultActiveKey={ [] }
            activeKey={ expanded ? 'simple-collapse-panel' : undefined }
            destroyInactivePanel
            ghost
            onChange={ props.onChange }
        >
            <Panel
                key="simple-collapse-panel"
                className="simple-collapse-panel"
                showArrow={ false }
            >
                { props.children }
            </Panel>
        </Collapse>
    );
};

/**
 * The default properties used for this component if values aren't given
 * to the component externally.
 */
SimpleCollapse.defaultProps = {
    className: undefined,
    style: undefined,
    expand: undefined,
};

/**
 * The type definitions of the properties this component accepts.
 */
SimpleCollapse.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    expand: PropTypes.bool,
};
